<template>
  <div class="select-family-member-component" v-bind:class="{loaded: loaded}">
    <a-list bordered size="small" v-if="showResults" class="results" itemLayout="horizontal"
            style="overflow: hidden;">
      <SelectableResultComponent v-if="hasMain" v-on:customer-selected="onCustomerSelected"
                                 :is-active="isActive(mainCustomer)"
                                 :customer="mainCustomer" :key="mainCustomer.id"/>
      <SelectableResultComponent v-if="hasPartner" v-on:customer-selected="onCustomerSelected"
                                 :is-active="isActive(partnerCustomer)"
                                 :customer="partnerCustomer" :key="partnerCustomer.id"/>
      <SelectableResultComponent v-if="hasChildren" v-on:customer-selected="onCustomerSelected"
                                 :is-active="isActive(child)"
                                 :customer="child" :key="index"
                                 v-for="(child, index) in children"/>
    </a-list>
  </div>
</template>

<script>
import SelectableResultComponent from "./SelectableResultComponent";
import customerApi from "~/api/customer"

export default {
  name: "SelectFamilyMemberComponent",
  components: {SelectableResultComponent},
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
    selectionVisible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      loaded: false,
      family: null,
      setValue: this.value
    };
  },
  created() {
    this.initFamily();
  },
  computed: {
    showResults() {
      return this.family !== null;
    },
    hasMain() {
      return this.family !== null && typeof this.family.main !== "undefined";
    },
    mainCustomer() {
      return this.hasMain ? this.family.main.data : null;
    },
    hasPartner() {
      return this.family !== null && typeof this.family.partner !== "undefined";
    },
    partnerCustomer() {
      return this.hasPartner ? this.family.partner.data : null;
    },
    hasChildren() {
      return this.family !== null && typeof this.family.children !== "undefined";
    },
    children() {
      return this.hasChildren ? this.family.children.data : [];
    },
  },
  methods: {
    initFamily() {
      customerApi.findFamily(this.customerId).then(response => {
        this.family = response.data;
        this.loaded = true;
      });
    },
    isActive(customer) {
      return this.setValue !== null
          && customer !== null
          && this.setValue.id === customer.id;
    },
    onCustomerSelected(customer) {
      this.setValue = customer;
      this.$emit('customer-selected', customer);
    }
  }
}
</script>
<style scoped>
</style>
